// Función optimizada para imágenes del hero - MÁXIMA COMPRESIÓN
export const compressHeroImage = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (event) => {
      const img = new Image()
      img.src = event.target?.result as string
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d', { alpha: false })

        // Dimensiones optimizadas para hero - más pequeñas para móvil
        const MAX_WIDTH = 1920 // Full HD max
        const MAX_HEIGHT = 1080
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height

        if (ctx) {
          // Optimización: fondo negro para hero
          ctx.fillStyle = '#000000'
          ctx.fillRect(0, 0, width, height)
          ctx.drawImage(img, 0, 0, width, height)

          // COMPRESIÓN AGRESIVA: 0.6 quality para hero
          const dataUrl = canvas.toDataURL('image/jpeg', 0.6)
          resolve(dataUrl)
        } else {
          reject(new Error('Could not get canvas context'))
        }
      }
      img.onerror = (error) => reject(error)
    }
    reader.onerror = (error) => reject(error)
  })
}

// Función para imágenes de proyectos - compresión moderada
export const compressImage = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (event) => {
      const img = new Image()
      img.src = event.target?.result as string
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        // Max dimensions reducidas
        const MAX_WIDTH = 1200
        const MAX_HEIGHT = 1200
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height

        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height)
          // Compresión mejorada: 0.65 quality
          const dataUrl = canvas.toDataURL('image/jpeg', 0.65)
          resolve(dataUrl)
        } else {
          reject(new Error('Could not get canvas context'))
        }
      }
      img.onerror = (error) => reject(error)
    }
    reader.onerror = (error) => reject(error)
  })
}

// Función específica para logos que PRESERVA LA TRANSPARENCIA
export const compressLogo = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (event) => {
      const img = new Image()
      img.src = event.target?.result as string
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d', { alpha: true })

        // Max dimensions para logos (más pequeño que fotos)
        const MAX_WIDTH = 400 // Reducido de 600 a 400
        const MAX_HEIGHT = 400
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height

        if (ctx) {
          // CRÍTICO: NO llenar el fondo - mantener transparencia
          ctx.clearRect(0, 0, width, height)
          ctx.drawImage(img, 0, 0, width, height)

          // PNG con compresión mejorada
          const dataUrl = canvas.toDataURL('image/png', 0.8)
          resolve(dataUrl)
        } else {
          reject(new Error('Could not get canvas context'))
        }
      }
      img.onerror = (error) => reject(error)
    }
    reader.onerror = (error) => reject(error)
  })
}
